import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'zoom-page-template',
  template: `
    <p>
      zoom-page-template works!
    </p>
  `,
  styles: []
})
export class ZoomPageTemplateComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
